import { AudioGraphService } from './services/AudioGraphService.js';
import { audioConfig } from './config';
import './components/audio-player.js';
import './components/effect-controls.js';
import './components/mixer-controls.js';

// Create the global audio service but don't initialize AudioContext yet
const audioService = new AudioGraphService();

// Make it available globally for components to use
(window as any).audioService = audioService;

// Log service initialization
audioService.addEventListener((event, data) => {
  console.log(`AudioGraphService event: ${event}`, data);
});

// Configure players with file lists after DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  const player1 = document.querySelector('audio-player[chainNumber="1"]') as any;
  const player2 = document.querySelector('audio-player[chainNumber="2"]') as any;
  const mixerControls = document.querySelector('mixer-controls') as any;
  const playOverlay = document.getElementById('play-overlay');
  
  if (player1) {
    player1.files = audioConfig.player1Files;
  }
  
  if (player2) {
    player2.files = audioConfig.player2Files;
  }

  // Handle play overlay click
  if (playOverlay) {
    playOverlay.addEventListener('click', async () => {
      // Initialize AudioContext first (required for iOS)
      try {
        await audioService.initializeAudioContext();
        console.log('AudioContext initialized successfully');
      } catch (error) {
        console.error('Failed to initialize AudioContext:', error);
        return;
      }

      mixerControls.togglePlayPause();
      // Hide overlay with fade out
      playOverlay.classList.add('hidden');
      
      // Remove overlay from DOM after transition
      setTimeout(() => {
        playOverlay.remove();
      }, 300);
    });
  }
});

console.log('Ambient2 application initialized');